import * as React from 'react';
import { reduxForm } from 'redux-form';
import { AgreementPageWithFormProps } from '../ClientAgreement';
import ContentContainer, { formSelector } from '../ContentContainer/Content';
import { connect } from 'react-redux';
import agreementStyles from '../ClientAgreement.module.css';
import styles from './AgreementPage10.module.css';
import cftLogo from '../cft_logo.jpg';

const AgreementPage10 = (props: AgreementPageWithFormProps) => (
  <ContentContainer {...props} requiredSignatures="initial" currentPage={10}>
    <div className={agreementStyles.contentHeader}>
      <img src={cftLogo} className={agreementStyles.cftLogo} alt="CFT Logo" />
      <br />
      <br />
      ADDITIONAL TERMS AND CONDITIONS
    </div>
    <ol className={styles.list}>
      <li>
        <b>
          Your SPA.{' '}
          <u>
            An SPA will be established for your benefit. Funds deposited to your SPA will be held
            for your benefit and will be beneficially owned by you.
          </u>{' '}
        </b>{' '}
        Your SPA is a limited purpose account and will not bear interest. You can make electronic
        fund transfers to and from your SPA only as provided in this Account Agreement. Only
        transactions directly related to your participation in a debt settlement program will be
        permitted. You may not write checks against the account or make in- person withdrawals at
        our offices or other locations. You may not use your SPA for any illegal purpose or in
        connection with internet gambling transactions. You have the right to close your SPA at any
        time and receive the full balance, minus any earned but uncollected fees, within seven (7)
        business days. Should you choose to close your SPA, please contact Finxera Customer Service
        or your DSP. Should you choose to close your SPA, we want to make sure that all payments to
        your creditors have cleared and your settlement(s) will remain in force, unless you
        specifically request otherwise.
      </li>
      <li>
        <b>Debits.</b> Our business days are Monday through Friday, excluding federal holidays, and
        other days on which banks in our state are permitted or required to be closed. Because of
        this, debits may occur up to 4 business days after the scheduled date. The debit amount is
        inclusive of fees that become due under your DSP Plan or this Account Agreement. A zero
        dollar transaction may be created to test the validity of your primary account.
      </li>
      <li>
        <b>Authorization to Transfer Funds and Share Information; Confidentiality.</b> You authorize
        us to: (a) initiate and facilitate transactions on your behalf; (b) share Personal
        Information (personally identifiable information about you, your SPA, and your SPA
        transactions) with your DSP; (c) accept and act upon SPA deposit, transfer and payment
        instructions that we receive from your DSP; and (d) confirm with your DSP instructions
        purporting to come from you before acting upon them. You authorize your DSP to share
        Personal and Plan-related information with us for purposes of facilitating payments to your
        creditors and administering your SPA. You authorize Finxera to disclose information to third
        parties about your SPA or the transfers you make: (i) where it is necessary for completing
        transfers; (ii) to verify the existence and condition of your SPA for a third party; (iii)
        to comply with government agency or court orders, or other legal or administrative reporting
        requirements; (iv) if you give us your prior written permission; (v) to our employees,
        auditors, affiliates, partners, or attorneys as needed; (vi) to protect the confidentiality
        or security of the bank's records pertaining to the consumer, service, product or
        transaction; (vii) as necessary to fulfill our obligations under this Account Agreement; or
        (viii) to comply with federal, state, or local laws, rules and other applicable legal
        requirements.
      </li>
      <li>
        <b>SPA Transactions.</b> Electronic funds transfers will be made into your SPA from another
        bank account that you designate (“Primary Account”). We will disburse available funds from
        your SPA to third parties based on instructions received from you in the order received. You
        are the only one who has the right to authorize transactions involving your SPA funds,
        either directly or through your DSP. You agree that Finxera shall not be required to monitor
        or question the instructions that Finxera receives from you through your DSP. You authorize
        us to initiate and facilitate disbursements from your SPA to pay Transfer Service (debit
        entries and payments made by us on your behalf) fees and Plan fees identified by your DSP to
        the extent of the immediately available funds in your SPA. We will not process disbursements
        when there are insufficient funds in your SPA. We will not provide back-up funding under
        this Account Agreement, nor do we guarantee that all requested transfers or payments can or
        will be made, when there are insufficient funds in your Primary Account or your SPA. We may
        deduct Transfer Service fees as they accrue. If there are insufficient funds in your SPA to
        pay your Transfer Service fees when incurred, you agree to pay them promptly upon request.
        Otherwise, we may deduct your Transfer Service fees from the next deposit to your SPA.
        Instructions received after our established transaction cutoff hour or on non-banking days
        will be processed on the next banking day.
      </li>
      <li>
        <b>Communicating With You; Consent to Contact by Electronic and Other Means.</b> You agree
        that we may contact you as provided in this paragraph. We may contact you for any lawful
        reason, including for the collection of amounts owed to us and for the offering of products
        or services in compliance with our Privacy Notice in effect from time to time. No such
        contact will be deemed unsolicited. You specifically agree that we may (i) contact you at
        any address (including email) or telephone number (including wireless cellular telephone,
        VoIP or ported landline number) as you may provide to us from time to time; (ii) use any
        means of communication, including, but not limited to, postal mail, electronic mail,
        telephone or other technology, to reach you; (iii){' '}
        <u>
          use automatic dialing and announcing devices which may play recorded messages (i.e.,
          robocalls);
        </u>{' '}
        and (iv) send text messages to your telephone numbers (message or data rates may be assessed
        by your carrier). You may withdraw this express written consent at any time by contacting us
        at P.O. Box 940, San Jose, CA 95113 and telling us specifically what address(es) or
        telephone number(s) not to use.
      </li>
      <li>
        <b>Our Liability.</b> During such time as we are providing services to you under this
        Account Agreement, if we do not complete a transfer to or from your SPA on time or in the
        correct amount according to the terms hereof, we will be liable for your losses or damages
        unless if (i) through no fault of ours, you do not have enough money in your SPA to make the
        transfer, (ii)circumstances beyond our control prevent the transfer, despite reasonable
        precautions we have taken, (iii) we have terminated this Account Agreement with you, (iv) we
        receive inaccurate or incomplete information needed to complete a transaction, (v)in the
        case of preauthorized transfers, we will not be liable where there is a breakdown of the
        system which would normally handle the transfer, (vi) the funds in the SPA are subject to
        legal action or administrative process or other encumbrance restricting their use or
        preventing a transfer to or from your SPA, (vii) we have reason to believe the transfer is
        unauthorized, and/or (viii) the transfer is subject to another exception set forth in this
        Account Agreement, or (ix) as provided by applicable law.
      </li>
      <li>
        <b>Stopping Payments.</b> If you want to stop making payments to your SPA, please contact
        Finxera Customer Service. We may charge you a fee, as shown in the Fee Schedule, for each
        stop-payment order you give. You may also contact your DSP, if you have questions. Any stop
        payment request shall be made by you at least three (3) business days before the
        preauthorized transfer.
      </li>
      <li>
        <b>Crediting and Payment Holds.</b> If you have arranged to have direct deposits made to
        your SPA at least once every 60 days from the same person or company, we will credit the
        amount of the transfer as of the date the funds for the transfer are received, subject to
        any holds. Funds that are deposited to your SPA by debit entry from your Primary Account may
        be subject to a hold of up to six (6) days to ensure good funds. A deposit credit is only
        temporary and is subject to potential reversal until final payment is confirmed. If we give
        you provisional credit for an automated clearing house (ACH) transfer, but do not receive
        final payment, you agree to pay us the full amount by other means without prior notice or
        demand.
      </li>
      <li>
        <b>Conflicting or Unclear Instructions.</b> If we receive conflicting instructions from you
        and your DSP, we will follow your instruction. If we are uncertain regarding the ownership
        of SPA funds, your identity, or the authority of any person to give SPA instructions, or if
        we believe that a SPA transaction may be fraudulent or may violate any law, or if the
        instructions we receive appear, in our sole discretion, to be unclear in any way, we may:(i)
        freeze and/or close your SPA and refuse any further transactions until we receive written
        proof, in form and substance satisfactory to us, of each person’s right and authority over
        the SPA funds; (ii) refuse the transaction in question; (iii) require your signature for the
        transaction in question; (iv) request instruction from a court of competent jurisdiction; or
        (v) continue to honor previous instructions received from you (directly or through your DSP)
        pending confirmation or clarification. We are not obligated to assert such rights or to
        notify you or your DSP in advance of exercising such rights.
      </li>
      <li>
        <b>Statements and Notices.</b> You may access specific information about your SPA by using
        the Password that we provide to you or by contacting Finxera Customer Service. “Password”
        means the security code and/or other method of authentication that you are provided to
        access SPA information electronically. If you have arranged to have direct deposits made to
        your SPA at least once every 60 days from the same person or company, you can call us at
        1-888-348-4543 to find out if the deposit has been made. All transaction history is also
        available for your convenience at{' '}
        <a target="_blank" href="https://www.CFTPay.com">
          www.CFTPay.com
        </a>
        . You may also request written copies of statements and notices by calling us at
        1-888-348-4543. You may also contact your Debt Settlement Provider, if you have questions.
      </li>
      <li>
        <b>Your Timely Review.</b> You agree to carefully review all statements, notices, and other
        information provided to you in connection with your SPA, the Transfer Service or this
        Account Agreement as soon as possible. Please visit{' '}
        <a target="_blank" href="https://www.CFTPay.com">
          www.CFTPay.com
        </a>{' '}
        on a regular basis to see if any notices have been posted for your review. You agree to
        notify us promptly of any erroneous, improper or unauthorized transactions involving your
        SPA funds. You agree that in no event will we or our agents be liable for special,
        incidental, consequential, exemplary or punitive damages unless applicable law provides
        otherwise. Unless otherwise required by law, an action or proceeding by you to enforce an
        obligation, duty or right arising under this Account Agreement or by law with respect to
        your SPA funds or the Transfer Service must be commenced no later than one (1) year after
        the day the cause of action accrues.
      </li>
      <li>
        <b>Unauthorized Transfers.</b> Tell Finxera at once if your statement shows transfers that
        you did not make, or if you need additional information regarding a transfer shown on your
        statement, by contacting Finxera Customer Service. If you do not give us notice within 60
        days after the first statement was provided to you on which the problem or error appeared,
        you may not get back any money you lost after the 60 days if we can prove that we could have
        stopped someone from taking the money if you had told us in time. See In Case of Errors or
        Questions About Your Electronic Transfers section for more information.
      </li>
      <li>
        <b>Fees.</b> You agree to pay the fees and charges set forth in the Fee Schedule on the
        first page of this Account Agreement, as amended from time to time.{' '}
        <u>You agree that fees may be deducted automatically from your SPA as they accrue</u>. The
        monthly service fee for the first calendar month of the Transfer Service will be prorated;
        it will not be charged if the Transfer Service begins within the last five (5) days of the
        month. Thereafter, the monthly service fee will be earned in full as of the first day of
        each calendar month and may be collected at that time, without proration, if the Transfer
        Service is terminated prior to the end of the month. Other fees and charges shall be deemed
        earned at the time of the transaction or event giving rise to the fee or charge.
      </li>
      <li>
        <b>Third Party Disputes/Indemnification.</b> You are responsible for resolving any disputes
        that arise between or among you, your creditors, your DSP, or any other third parties.
        <u>
          Finxera is not a party to any negotiations or agreements between or among you and any of
          your creditors or your DSP, and assumes no obligation to you for any of their actions,
          omissions, or obligations
        </u>
        . We have no involvement in, nor any responsibility with respect to, your Plan or the
        results that you expect from your Plan. You agree to indemnify, defend and hold us and our
        officers, directors, agents, employees and affiliates harmless from any and all claims,
        demands, actions, charges, fines, penalties and damages arising out of: (a) the actions or
        omissions of your DSP, your creditors or third parties not within our immediate control, (b)
        actions we take at your request (whether directly or through your DSP or another third
        party) or in accordance with this Account Agreement, and (c) your actions and/or omissions.
        This provision shall survive the termination of your SPA.
      </li>
      <li>
        <b>Governing Law.</b> Except as provided in Paragraph 23 (Arbitration Provision-Agreement to
        Arbitrate), Federal law and, to the extent not preempted by federal law, the laws of the
        State of California shall govern this Account Agreement. If any part of this Account
        Agreement is declared void or unenforceable, the remainder of the terms of this Account
        Agreement shall remain in full force and effect and the agreement shall be interpreted to
        give fullest effect to the intentions of the parties as set out in this Account Agreement.
      </li>
      <li>
        <b>Privacy Policy/USA PATRIOT Act Compliance.</b> We are committed to securing the privacy
        of your Personal Information. We allow only approved personnel to have access to your
        Personal Information, and we share your Personal Information only with your consent or as
        required or permitted by law. Please see the attached Privacy Notices for more details. We
        assume no obligation for the use or disclosure of your Personal Information by any DSP.
        Please see our Privacy Notice.
        <br />
        <b>
          <u>Important Information About Procedures for Opening a New Account</u>:
        </b>{' '}
        To help the government fight the funding of terrorism and money laundering activities,
        financial institutions are required by Federal law to obtain, verify and record information
        that identifies each individual that opens a SPA. What this means for individuals: When you
        open an SPA, we will ask you for your name, residence address, date of birth, social
        security number, and other information that will allow us to identify you. We may also ask
        to see your driver’s license, passport or other identifying document(s).
      </li>
      <li>
        <b>Changes in Terms.</b> Subject to applicable law, we may at any time add new terms or
        delete or change the terms of this Account Agreement as required by law or desirable in our
        sole discretion. You will be notified of any change prior to the effective date of such
        change in the manner provided by applicable law. You may close your SPA if you do not accept
        the changes to the terms of this Account Agreement. You must promptly notify Finxera, if you
        choose to close the SPA.
      </li>
      <li>
        <b>Assignment.</b> This Account Agreement will bind and inure to the benefit of the
        respective successors and assigns of each party; provided, however, that you may not assign
        this Account Agreement or any rights or duties hereunder without our prior written consent
        and any prohibited assignment is absolutely void. No consent to an assignment by us will
        release you from your obligations under this Account Agreement. Subject to any applicable
        requirements of law, we may assign this Account Agreement and its rights and duties
        hereunder and no consent or approval by you is required in connection with any such
        assignment. In connection with any assignment, we may disclose all documents and information
        that we now or hereafter may have relating to you. To the extent that Finxera assigns its
        rights and obligations hereunder to another party, Finxera thereafter shall be released from
        such assigned obligations to you and such assignment will affect a novation between you and
        such other party.
      </li>
      <li>
        <b>Changes in Your Contact Information; Assignment.</b> <br /> We may send notices to you by
        periodic statement posted at{' '}
        <a target="_blank" href="https://www.CFTPay.com">
          www.CFTPay.com
        </a>
        , by email or through your DSP. You agree to notify us promptly if any of your contact
        information changes.
      </li>
      <li>
        <b>Termination and Suspension.</b> You or we may terminate or suspend this Account Agreement
        with or without cause at any time with notice. The Transfer Service may be suspended if we
        are uncertain as to anyone’s authority to give SPA instructions on your behalf or there is
        any uncertainty regarding the identity or authority of the person providing SPA
        instructions. Your termination or suspension of this Account Agreement will not affect any
        of our rights or your obligations arising under this Account Agreement prior to such
        termination or suspension.
      </li>
      <li>
        <b>Call Monitoring/Recording.</b> You authorize us to listen to and record any telephone
        calls between you and us to evaluate the quality of our services or for any other lawful
        purpose.
      </li>
      <li>
        <b>
          Postdated Checks, Restricted Endorsement Checks and Other Disputed or Qualified Payments.
        </b>{' '}
        We can accept postdated deposit checks without losing any of our rights under this Account
        Agreement. We are under no obligation to hold a postdated check and we reserve the right to
        process every item presented as if dated the same date received by us or our check
        processor. Any damages you incur that we may be liable for are limited to actual damages not
        to exceed the amount of the check. You agree not to send us checks marked “paid in full,”
        “without recourse,” or similar language. If you send such a check, Finxera may accept it
        without waiving any of Finxera’s rights under this Account Agreement.{' '}
        <u>
          All notices and written communications concerning postdated checks, restricted endorsement
          checks, or any other disputed or nonconforming check, must be mailed or delivered to:
          Finxera Customer Disputes, P.O. Box 940, San Jose, CA. 95113.
        </u>
      </li>
      <li>
        <b>
          IMPORTANT DISPUTE RESOLUTION PROVISIONS – ARBITRATION OF DISPUTES, CHOICE OF LAW, CLASS
          ACTION WAIVER AND LIMITATION OF ACTIONS.
        </b>{' '}
        The Parties agree that any dispute, controversy, claim or disagreement (collectively
        referred to as a “Dispute” or “Disputes”) between or among them, of any kind, including but
        not limited to any Disputes arising out of, concerning, or relating to this Account
        Agreement and the Finxera Services provided thereunder, shall be resolved on an individual
        basis solely through final and binding confidential arbitration, conducted before a single
        arbitrator, administered by Judicial Arbitration and Mediation Services (“JAMS”), pursuant
        to its Streamlined Arbitration Rules & Procedures, which may be viewed at{' '}
        <a target="_blank" href="https://www.jamsadr.com">
          www.jamsadr.com
        </a>{' '}
        or by calling JAMS customer service at 800-352-5267. Unless otherwise agreed to by the
        Parties, the arbitration shall be conducted within your county of residence at the time the
        Dispute arises and shall be resolved in accordance with the procedural laws of the Federal
        Arbitration Act and any substantive laws of the state of your residence at the time the
        Dispute arises. If for any reason JAMS cannot, will not, or ceases to serve as an
        arbitration administrator, you or we may substitute another widely recognized arbitration
        organization that uses a similar code of procedure and is mutually acceptable to the
        parties. An arbitrator may decide a Dispute upon the submission of documents alone. Either
        party may submit relevant information, documents or exhibits to the arbitrator for
        consideration in deciding a Dispute. Each Party agrees to continue performing its
        obligations under this Account Agreement while any Dispute is being resolved except to the
        extent the issue in dispute precludes performance (dispute over payment will not be deemed
        to preclude performance). The Parties agree that either party may bring claims against the
        other party only in his, her or its individual capacity and not as a plaintiff, claimant or
        class member in any purported class action or representative proceeding. The Parties also
        agree that the arbitrator may not consolidate proceedings of more than one person's claims,
        and may not otherwise preside over any form of representative or class proceeding. The
        decision of an arbitrator is as enforceable as any court order and may be subject to very
        limited review by a court. The award rendered by the arbitrator shall be final and binding
        on all parties. Judgment on the award made by the arbitrator may be entered by any competent
        court with jurisdiction to enforce the award. You or we may seek remedies in small claims
        court or provisional judicial remedies without arbitrating. You may opt out of this
        arbitration provision within 30 days of signing this Account Agreement by sending a signed,
        written notice to Finxera at P.O. Box 940, San Jose, CA. 95113.
        <br />
        <br />
        <b>ARBITRATION COSTS.</b> We will advance the costs of filing any arbitration (excluding
        your attorneys’ and/or expert witness’ fees). Each party will pay for its respective
        attorneys’, experts’ and witness fees, regardless of which party prevails in the arbitration
        or any appeal. If either party fails to submit to arbitration following a proper demand to
        do so or fails to comply with the terms of an award or judgment following an arbitrator’s
        decision, such party shall bear the costs and expenses, including reasonable attorneys’
        fees, incurred by the party compelling arbitration or seeking to enforce the award or
        judgment.
        <br />
        <b>
          BINDING ARBITRATION MEANS THAT BOTH PARTIES GIVE UP THE RIGHT TO A TRIAL BY A JURY. IT
          ALSO MEANS THAT BOTH PARTIES GIVE UP THE RIGHT TO APPEAL FROM THE ARBITRATOR’S RULING
          EXCEPT FOR A NARROW RANGE OF ISSUES THAT CAN OR MAY BE APPEALED. IT ALSO MEANS THAT
          DISCOVERY MAY BE SEVERELY LIMITED BY THE ARBITRATOR.
        </b>
        <br />
        <br />
        <b>CONTINUED EFFECT OF ARBITRATION PROVISION.</b> This Arbitration Provision will continue
        to govern any Disputes that may arise without regard to any termination or cancellation of
        your SPA. If any portion of this Arbitration Provision (other than the provisions
        prohibiting class-wide arbitration, joinder or consolidation) is deemed invalid or
        unenforceable under the FAA (Federal Arbitration Act (“FAA”), 9 U.S.C. §§ 1 et seq., as
        amended), it will not invalidate the remaining portions of this Arbitration Provision. If a
        conflict or inconsistency arises between the code of procedures of the selected arbitration
        administrator and this Arbitration Provision, this Arbitration Provision will control.
      </li>
      <li>
        <b>In Case of Errors or Questions About Your Electronic Transfers</b>
        <br />
        Telephone us at 1-888-348-4543 or write us at P.O. Box 940, San Jose, CA. 95113 as soon as
        you can, if you think your statement is wrong or if you need more information about a
        transfer listed on the statement. We must hear from you no later than 60 days after we sent
        the FIRST statement on which the problem or error appeared. To dispute a transaction or
        statement:
        <br />
        <br />
        <ul>
          <li>Provide your name and SPA number (if any).</li>
          <li>
            Describe the error or the disputed transfer, and explain as clearly as possible why you
            believe the transaction is in error or why you need more information.
          </li>
          <li>Provide the dollar amount of the suspected error.</li>
          <li>Confirm all oral disputes in writing within 10 business days.</li>
          <li>Provide supporting documentation if available.</li>
        </ul>
        <br />
        We will determine whether an error occurred within 10 business days after we hear from you
        and will correct any error promptly. If we need more time, however, we may take up to 45
        days to investigate your complaint or question. If we decide to do this, we will credit your
        SPA within 10 business days for the amount you think is in error, so that you will have the
        use of the money during the time it takes us to complete our investigation. If we ask you to
        put your complaint or question in writing and we do not receive it within 10 business days,
        we may not credit your SPA.
        <br />
        For errors involving a new SPA, we may take up to 90 days to investigate your complaint or
        question. For new SPAs, we may take up to 20 business days to credit your SPA for the amount
        you think is in error. The extended time periods for new SPAs apply to all electronic fund
        transfers that occur within the first 30 days after the first deposit is made.
        <br />
        We will tell you the results within three (3) business days after completing our
        investigation. If we decide that there was no error, we will send you a written explanation.
        You may ask for copies of the documents that we used in our investigation.
      </li>
      <li>
        <b>CONSENT TO ELECTRONIC DISCLOSURES</b>
        <br />
        By signing this document, you agree that we may provide all disclosures, statements,
        notices, privacy policies, and other communications related to the Account Agreement, the
        Transfer Service or your SPA, including disclosures required by law (collectively,
        “Electronic Communications”) electronically. We will notify you when a new Electronic
        Communication has been posted on our website at{' '}
        <a target="_blank" href="https://www.CFTPay.com">
          www.CFTPay.com
        </a>
        . When you receive the notification, you agree to promptly visit our website to view the
        Electronic Communication. You may log in to our website using the Password that we provide
        to you. “Password” means the security code and/or other method of authentication that you
        are provided to access SPA information electronically. You agree not to disclose your
        Password to others and to keep it secure. You also agree that your use of your Password
        constitutes, and you intend it to constitute, your electronic or digital signature on any
        document or record where your signature is requested or required. By logging in to our
        website and using your Password, you demonstrate that you can access information that we
        post on our website. This consent only applies to this SPA.
        <br />
        Upon your request, we will send you a paper copy of any material provided electronically
        pursuant to this consent You have the right to withdraw consent but if you do, we may
        terminate the Account Agreement. To withdraw your consent to electronic disclosures, update
        your electronic mail address or request paper copies, contact Finxera Customer Service, at
        P.O. Box 940, San Jose, CA. 95113 or{' '}
        <a target="_blank" href="https://www.CFTPay.com">
          www.CFTPay.com
        </a>{' '}
        or call toll free 1-888-348-4543. If Finxera changes its hardware or software requirements,
        then you may withdraw your consent to electronic information without a fee, condition, or
        consequence.
        <br />
        To access and retain communications, you must meet at least the following requirements: (i)
        access to a personal computer or equivalent device capable of connecting to the Internet,
        and that supports the following requirements; (ii) an Internet Browser that supports HTML
        4.0 and SSL-encryption; (iii) software which permits you to receive and access PDF files;
        and: (iv) means to print or store notices and information through your browser software. All
        communications in either electronic or paper format from us to you will be considered “in
        writing.” Please print or download a copy of any Electronic Communication that is important
        to you for your records.
      </li>
    </ol>
  </ContentContainer>
);

const form = reduxForm({
  form: 'clientAgreement',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(AgreementPage10 as any);

export default connect(state => ({
  name: formSelector(state, 'name'),
  existingInitial: formSelector(state, 'clientInitials')
}))(form) as any;
